import React from 'react'

const ArrowDown = ({color}) => {
    return (
       <svg width="22" height="12" viewBox="0 0 14 9" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0.999569 8.03027L7.02957 2.00027L13.0596 8.03027" stroke="#00854E" stroke-width="2" stroke-miterlimit="20"/>
    </svg>
    )
}

export default ArrowDown